import { useEffect, useState } from "react";
import { Tabs, Typography, Flex } from "antd";
import { getBusDetailedView } from "../../redux/slices/BusSlice";
import { getDropdownData } from "../../redux/slices/EnqMngtSlice";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import BackButton from "../../components/CustomButton/BackButton";
import CustomCard from "../../components/CustomCard/CustomCard";
import EnquiryDetails from "./Components/EnquiryDetails";
import EnquiryActivityLog from "./Components/EnquiryActivityLog.jsx";
import "./EnqMngt.scss";
import { TITLE_TXT } from "../../constants/constants";
import { capitalizeEntireWord } from "../../helpers/helpers";

const { Text } = Typography;

const EnquiryViewDetails = () => {
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const location = useLocation();
  const { org } = location.state || {};
  const { busDetailedViewData, loading } = useSelector(
    (state) => state?.business,
  );
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    dispatch(
      getBusDetailedView({
        orgId,
        dealCategoryId: org?.dealCategoryId,
      }),
    );

    dispatch(getDropdownData());
  }, [dispatch, orgId, org?.dealCategoryId]);

  const items = [
    {
      key: "1",
      label: capitalizeEntireWord(TITLE_TXT.BUS_DETS),
      children: (
        <EnquiryDetails
          businessDetailesData={busDetailedViewData}
          orgId={orgId}
          status={org?.statusId}
          readOnly
        />
      ),
    },
    {
      key: "2",
      label: "Activity Log",
      children: <EnquiryActivityLog orgId={orgId} dealCategoryId={org?.dealCategoryId} />,
    },
  ].filter(Boolean);

  return (
    <div className="bus-details-container">
      {/* Back button + title */}
      <Flex align="center" style={{ marginBottom: 16 }}>
        <BackButton />

        <Text className="name" style={{ marginLeft: 24 }}>
          {`Viewing Details for ${
            busDetailedViewData?.busDetails?.busName || org?.busName || ""
          }`}
        </Text>
      </Flex>

      <CustomCard>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          className="bus-details-tabs"
          tabBarExtraContent={
            loading ? <Text type="secondary">Loading...</Text> : null
          }
        />
      </CustomCard>
    </div>
  );
};

export default EnquiryViewDetails;

